export const helper = {

    data(){
        return {

        }
    },
    methods:{
        isSmallTouchDevice(){
            let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
            return width<700;
            //return ("ontouchstart" in document.documentElement);
        },
        isMobileTouchDevice(){
			return  ("ontouchstart" in document.documentElement);
		},
        getArrayAsString(dataset,ids){
			let res=this.getAsStringArray(dataset,ids);
			if(this._.isArray(res)){
				res=this._.join(res," | ");
			}
			return res;
        },
        getAsStringArray(dataset,ids){
			let res="";
			if(this._.isArray(ids)){
				res=this._.filter(dataset,(c)=> { return this._.includes(ids, c.id) });
				res=this._.map(res, 'name');
			}
			return res;
        },
        compareIdWithIds(ids,id){
			let res=false;
			if(this._.isArray(ids)){
				res=this._.includes(ids, id);
			}
			return res;
        },
        getModifiedImage(img){
			if(this._.isString(img)){
                img=img.replace("https://drive.google.com/open", "https://drive.google.com/uc");
                if(img.startsWith('/')){
                    img="https://handelt-gemeinsam.de"+img;
                }
			}else{
				img="";
			}
			return img;
        },
        filterEmptyData(data){
            return this._.filter(data,(d)=>{
                return (d!=""&&d!="0" && d!=null);
            });
        },
        scrollToTop () {
            //window.scrollTo(0, 0)
        },
        newUuid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },
        removeHtmlTags(str){
            if(this._.isString(str)){
                str=str.replace(/<[^>]*>?/gm, '');
            }
            return str;
        },
        getCoord(row){
            let res="";
            if(row){
                if(row.c_city!=null && row.c_city!="" && row.street!=null && row.street!=""){
                    let params=[row.street];//TODO unternehemn dazu?
                    if(row.plz!=null && row.plz!=""){
                        params.push(row.plz+" "+row.c_city);
                    }else{
                        params.push(row.c_city);
                    }
                    

                    let paramsString=params.join(' | ');

                    //res="<a href='https://www.google.com/maps/search/?api=1&"+encodeURIComponent(paramsString)+"' target='_blank'>";
                    //res+=paramsString;
                    //res+="</a>";

                    //TODO Link einbauen
                    res=paramsString;

                }
            }
            return res;
        },
        getContact(row){
            
            let res=[];
            if(row){
                //Email
              if(row.email!=null && row.email!=""){
                res.push(row.email);
              }
              //Tel
              if(row.tel!=null && row.tel!=""){
                res.push(row.tel);
                  //res.push("<a class='telnr' href='tel:"+row.tel+"'>"+row.tel+"</a>");
              }
            }
      
            return this._.isEmpty(res)?"":res.join(' | ');
          },
            offset(el) {
            let rect = el.getBoundingClientRect(),
            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
        }
    }
}